export default __webpack_public_path__ + "static/media/splash01.669b2024.jpg";